import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, MapPinIcon, ArrowDownIcon } from 'lucide-react';
import { HERO_IMG, PAGO_LINK } from '../../data/retiro';
export function Hero() {
  return <section id="top" className="relative flex min-h-screen w-full items-center justify-center overflow-hidden" data-id="element-162" data-mp="cvl4x6cevgu3">
      <div className="absolute inset-0" data-id="element-163" data-mp="hwikrc9y7ysf">
        <img src={HERO_IMG} alt="Amanecer sobre la Laguna de los Siete Colores en Bacalar" className="h-full w-full object-cover" data-id="element-164" data-mp="muae8aq8rsyq" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(42,36,32,0.55) 0%, rgba(42,36,32,0.25) 40%, rgba(42,36,32,0.78) 100%)'
      }} data-id="element-165" data-mp="qtj8dgp71sut" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-5 pt-24 text-center text-white" data-id="element-166" data-mp="15l1tfswwudl1">
        <motion.span initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/30 px-4 py-1.5 text-xs uppercase tracking-[0.3em] backdrop-blur-sm" data-id="element-167" data-mp="1akejsnmzq2sd">
          Embajadores del Alma · Bacalar
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1
      }} className="font-heading text-4xl font-light leading-[1.05] sm:text-6xl md:text-7xl" data-id="element-168" data-mp="setvsd5ltywp">
          El Último
          <br data-id="element-169" data-mp="1b4jql09dakom" />
          <span style={{
          color: 'var(--jasmine)'
        }} data-id="element-170" data-mp="1b5bj227o42ao">
            Nudo
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.25
      }} className="mt-6 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg" data-id="element-171" data-mp="16byzw7lrcnpb">
          Cierra el año sin enredos. Crea el próximo con intención. Un
          seminario-retiro holístico para desatar y volver a nuestra esencia.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.4
      }} className="mt-8 flex flex-col items-center gap-4 text-sm text-white/90 sm:flex-row sm:gap-8" data-id="element-172" data-mp="2mu95sivw48lj">
          <span className="inline-flex items-center gap-2" data-id="element-173" data-mp="642aax7d0ptk">
            <CalendarDaysIcon className="h-4 w-4" style={{
            color: 'var(--jasmine)'
          }} data-id="element-174" data-mp="b3op3b2u6e4h" />
            26 de noviembre — 1 de diciembre
          </span>
          <span className="hidden h-4 w-px bg-white/30 sm:block" data-id="element-175" data-mp="1qpqv1vtp2l1n" />
          <span className="inline-flex items-center gap-2" data-id="element-176" data-mp="25dvgv8o1ncon">
            <MapPinIcon className="h-4 w-4" style={{
            color: 'var(--jasmine)'
          }} data-id="element-177" data-mp="20m3qay4w16yi" />
            Bacalar + Cancún · México
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.55
      }} className="mt-10 flex flex-col items-center gap-3 sm:flex-row" data-id="element-178" data-mp="2acokm9dj3pbm">
          <a href={PAGO_LINK} target="_blank" rel="noreferrer" className="rounded-full px-8 py-3.5 text-sm font-medium text-white transition-transform hover:scale-[1.04]" style={{
          backgroundColor: 'var(--darkgoldenrod)'
        }} data-id="element-179" data-mp="tzrcr9nqs85v">
            Separa tu cupo · 444 USD
          </a>
          <a href="#bacalar" className="rounded-full border border-white/40 px-8 py-3.5 text-sm font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/10" data-id="element-180" data-mp="10f8azpzolrjf">
            Ver experiencias
          </a>
        </motion.div>
      </div>

      <motion.a href="#bacalar" aria-label="Desplázate hacia abajo" className="absolute bottom-8 z-10 text-white/70" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-181" data-mp="cnjbnpog02sz">
        <ArrowDownIcon className="h-6 w-6" data-id="element-182" data-mp="3l3cs64irxea1" />
      </motion.a>
    </section>;
}